// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LUyRu703uBUAOn {
  margin-top: -10px;
}
.mrKmNuZ2tOoz20 {
  margin-top: 10px;
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-semibold, 600);
}
.VDHLQVZjbPfGYO {
  margin-left: 2px;
  color: var(--ds-text-danger, '#DE350B');
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox": `LUyRu703uBUAOn`,
	"label": `mrKmNuZ2tOoz20`,
	"required": `VDHLQVZjbPfGYO`
};
export default ___CSS_LOADER_EXPORT___;
